export const needGetPersonalSetting = (url?: string) => {
  // 进入登录页面即根据二级域名加载个性化设置
  const part1 = url ? url.split('.')[0] : window.location.href.split('.')[0]
  // 针对localhost增加的判断
  const part2 = url ? url.split('.')[1] : window.location.href.split('.')[1]
  const domain = part1.split('//')[1]
  // 排除localhost；二级域名存在；排除数字域名
  return !!(part2 && domain && isNaN(Number(domain)))
}
